"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PinCursorMarker = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _PinOff = _interopRequireDefault(require("@react/react-spectrum/Icon/PinOff"));

var _utils = require("./utils");

var _Pin = _interopRequireDefault(require("../../style/annotations/Pin.scss"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DIAMETER = 24;
var POINTER_EVENTS_SUPPORTED = !!window.PointerEvent;
/**
 * PinCursorMarker component
 */

var PinCursorMarker = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PinCursorMarker, _React$PureComponent);

  var _super = _createSuper(PinCursorMarker);

  /**
   * Constructor for component
   * @param {object} props - props sent to the component
   * @returns {undefined}
   */
  function PinCursorMarker(props) {
    var _this;

    _classCallCheck(this, PinCursorMarker);

    _this = _super.call(this, props);
    _this.state = {};
    _this.trackMouseMovement = _this.trackMouseMovement.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Called when component is added to DOM.
   * @returns {undefined}
   */


  _createClass(PinCursorMarker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$currentDo = this.props.currentDocument,
          currentDocument = _this$props$currentDo === void 0 ? document : _this$props$currentDo;
      var curWindow = currentDocument.defaultView;

      if (POINTER_EVENTS_SUPPORTED) {
        curWindow.addEventListener('pointermove', this.trackMouseMovement);
      } else {
        curWindow.addEventListener('mousemove', this.trackMouseMovement);
        curWindow.addEventListener('touchstart', this.trackMouseMovement);
        curWindow.addEventListener('touchmove', this.trackMouseMovement);
      }
    }
    /**
     * Called when component is about to be removed from DOM.
     * @returns {undefined}
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props$currentDo2 = this.props.currentDocument,
          currentDocument = _this$props$currentDo2 === void 0 ? document : _this$props$currentDo2;
      var curWindow = currentDocument.defaultView;

      if (POINTER_EVENTS_SUPPORTED) {
        curWindow.removeEventListener('pointermove', this.trackMouseMovement);
      } else {
        curWindow.removeEventListener('mousemove', this.trackMouseMovement);
        curWindow.removeEventListener('touchstart', this.trackMouseMovement);
        curWindow.removeEventListener('touchmove', this.trackMouseMovement);
      }
    }
    /**
     * Method to track movement of the user's mouse cursor
     * @param {EventObject} evt - javascript event object
     * @returns {undefined}
     */

  }, {
    key: "trackMouseMovement",
    value: function trackMouseMovement(evt) {
      var onMove = this.props.onMove;

      var _getClientCoordinates = (0, _utils.getClientCoordinatesFromEvent)(evt),
          x = _getClientCoordinates.x,
          y = _getClientCoordinates.y;

      this.setState({
        cursorX: x,
        cursorY: y
      });

      if (onMove) {
        onMove(evt);
      }
    }
    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          annotationColor = _this$props.annotationColor,
          annotationTypes = _this$props.annotationTypes,
          _this$props$currentDo3 = _this$props.currentDocument,
          currentDocument = _this$props$currentDo3 === void 0 ? document : _this$props$currentDo3,
          touchControls = _this$props.touchControls,
          offsetX = _this$props.offsetX,
          offsetY = _this$props.offsetY,
          size = _this$props.size;
      var _this$state = this.state,
          cursorX = _this$state.cursorX,
          cursorY = _this$state.cursorY;
      var adjustedDiameter = size === 'L' ? DIAMETER * 2 : DIAMETER;

      if (cursorX && cursorY) {
        var style = {
          borderRadius: adjustedDiameter / 2,
          height: adjustedDiameter,
          left: cursorX - adjustedDiameter / 2 - offsetX,
          top: cursorY - adjustedDiameter / 2 - offsetY,
          width: adjustedDiameter
        };

        if (annotationTypes) {
          style.backgroundColor = annotationColor;
        }

        return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(_Pin.default.cursorMarker).concat(touchControls ? ' compact' : ''),
          style: style
        }, /*#__PURE__*/_react.default.createElement(_PinOff.default, {
          size: "XS"
        })), currentDocument.body);
      }

      return null;
    }
  }]);

  return PinCursorMarker;
}(_react.default.PureComponent);

exports.PinCursorMarker = PinCursorMarker;
PinCursorMarker.propTypes = {
  annotationColor: _propTypes.default.string,
  annotationTypes: _propTypes.default.object,
  currentDocument: _propTypes.default.object,
  offsetX: _propTypes.default.number,
  offsetY: _propTypes.default.number,
  onMove: _propTypes.default.func,
  touchControls: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['S', 'L'])
};
/**
 * Pin component
 * @param {Object} props - property object
 * @returns {ReactElement} markup
 */

var Pin = function Pin(_ref) {
  var annotation = _ref.annotation,
      annotationTypes = _ref.annotationTypes,
      annotationColor = _ref.annotationColor,
      commentProposedForDelete = _ref.commentProposedForDelete,
      compactLayout = _ref.compactLayout,
      disableInteraction = _ref.disableInteraction,
      hasAnnotationLocation = _ref.hasAnnotationLocation,
      hoveredAnnotation = _ref.hoveredAnnotation,
      imsData = _ref.imsData,
      isPlacingAnnotation = _ref.isPlacingAnnotation,
      onPinDown = _ref.onPinDown,
      onPinHover = _ref.onPinHover,
      annotationId = _ref.annotationId,
      annotatingItmId = _ref.annotatingItmId,
      scaleFactorX = _ref.scaleFactorX,
      scaleFactorY = _ref.scaleFactorY,
      showResolvedComments = _ref.showResolvedComments,
      touchControls = _ref.touchControls,
      touchPressed = _ref.touchPressed;
  var x = (0, _lodash.default)(annotation, 'target.selector.noteX') * scaleFactorX;
  var y = (0, _lodash.default)(annotation, 'target.selector.noteY') * scaleFactorY;
  var content = annotationId === 'annotation-placeholder' || annotationTypes ? /*#__PURE__*/_react.default.createElement(_PinOff.default, {
    size: "XS"
  }) : annotation.pinNum;
  var style = {
    borderRadius: DIAMETER,
    height: DIAMETER,
    lineHeight: "".concat(DIAMETER, "px"),
    left: x - DIAMETER / 2,
    top: y - DIAMETER / 2,
    width: DIAMETER
  };

  if (annotationId === annotatingItmId && !touchPressed && (isPlacingAnnotation || hasAnnotationLocation) || isPlacingAnnotation && annotationId === 'annotation-placeholder') {
    style.display = 'none';
  }

  var showMove = false;

  if (!showResolvedComments && !commentProposedForDelete && imsData.id === (0, _lodash.default)(annotation, 'creator.id') && !hasAnnotationLocation || annotationId === 'annotation-placeholder' && (!annotatingItmId || annotatingItmId === 'root')) {
    showMove = true;
  }

  var classes = (0, _classnames.default)(_Pin.default.component, _constants.ANNOTATION_CLASS_PREFIX, {
    'temp-pin': annotationId === 'annotation-placeholder',
    'can-move': showMove,
    'hovered-pin': hoveredAnnotation === annotationId || commentProposedForDelete && annotationId === commentProposedForDelete.id,
    'ignore-mouse-events': isPlacingAnnotation || disableInteraction,
    'touch-size': !compactLayout && touchControls
  });

  if (annotationTypes) {
    if (annotationId === 'annotation-placeholder') {
      var tempAnnotationColor = (0, _lodash.default)(annotation, 'target.selector.strokeColor') || annotationColor || '#B80000';
      style.borderColor = tempAnnotationColor;
      style.color = tempAnnotationColor;
    } else {
      style.backgroundColor = (0, _lodash.default)(annotation, 'target.selector.strokeColor') || '#B80000';
    }
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-html2canvas-ignore": annotationId === 'annotation-placeholder' ? null : true,
    className: classes,
    style: style,
    onPointerDown: POINTER_EVENTS_SUPPORTED ? onPinDown : undefined,
    onMouseDown: POINTER_EVENTS_SUPPORTED ? undefined : onPinDown,
    onTouchStart: POINTER_EVENTS_SUPPORTED ? undefined : onPinDown,
    onMouseEnter: onPinHover,
    onMouseLeave: onPinHover,
    "data-annotationid": annotationId,
    "data-annotationtype": "pin"
  }, content);
};

Pin.propTypes = {
  annotation: _propTypes.default.object,
  annotationColor: _propTypes.default.string,
  annotationTypes: _propTypes.default.object,
  commentProposedForDelete: _propTypes.default.object,
  compactLayout: _propTypes.default.bool,
  disableInteraction: _propTypes.default.bool,
  hasAnnotationLocation: _propTypes.default.bool,
  hoveredAnnotation: _propTypes.default.string,
  imsData: _propTypes.default.object,
  isPlacingAnnotation: _propTypes.default.bool,
  markHovered: _propTypes.default.bool,
  onPinDown: _propTypes.default.func,
  onPinHover: _propTypes.default.func,
  annotationId: _propTypes.default.string,
  annotatingItmId: _propTypes.default.string,
  scaleFactorX: _propTypes.default.number,
  scaleFactorY: _propTypes.default.number,
  showResolvedComments: _propTypes.default.bool,
  touchControls: _propTypes.default.bool,
  touchPressed: _propTypes.default.bool
};
var _default = Pin;
exports.default = _default;